import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ConfirmationNumberRoundedIcon from "@mui/icons-material/ConfirmationNumberRounded";
import TicketEditor from "../pieces/TicketEditor";

const blockSx = {
  p: { xs: 1.4, md: 1.8 },
  borderRadius: 2,
  border: "1px solid rgba(255,255,255,0.08)",
  bgcolor: "rgba(255,255,255,0.025)",
};

export default function IngressosStep({ state, actions, errors }) {
  return (
    <Stack spacing={2}>
      <Box sx={blockSx}>
        <Stack direction="row" spacing={1.1} alignItems="center" sx={{ mb: 0.8 }}>
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: 2,
              display: "grid",
              placeItems: "center",
              bgcolor: "rgba(0,225,255,0.12)",
              color: "#8ef4ff",
            }}
          >
            <ConfirmationNumberRoundedIcon sx={{ fontSize: 20 }} />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 900, fontSize: "1rem", color: "rgba(255,255,255,0.94)" }}>
              Tipos de ingresso
            </Typography>
            <Typography sx={{ fontSize: "0.84rem", color: "rgba(255,255,255,0.5)", lineHeight: 1.6 }}>
              Crie lotes ou setores mantendo preço, quantidade e visibilidade bem definidos.
            </Typography>
          </Box>
        </Stack>

        {errors["ingressos"] ? (
          <Box
            sx={{
              mb: 1.6,
              p: 1.4,
              borderRadius: 2,
              border: "1px solid rgba(255,90,90,0.28)",
              bgcolor: "rgba(255,90,90,0.08)",
            }}
          >
            <Typography sx={{ color: "#ffb3b3", fontWeight: 700, fontSize: 13.5 }}>
              {errors["ingressos"]}
            </Typography>
          </Box>
        ) : null}

        <Stack spacing={1.4}>
          {state.ingressos.map((t, index) => (
            <TicketEditor
              key={t.id}
              ticket={t}
              index={index}
              onChange={(patch) => actions.updateTicket(t.id, patch)}
              onRemove={() => actions.removeTicket(t.id)}
              errors={errors}
            />
          ))}

          <Button
            fullWidth
            variant="outlined"
            onClick={actions.addTicket}
            startIcon={<AddRoundedIcon />}
            sx={{
              minHeight: 54,
              borderRadius: 2,
              borderStyle: "dashed",
              borderColor: "rgba(255,255,255,0.18)",
              fontWeight: 900,
              textTransform: "none",
            }}
          >
            Adicionar novo ingresso
          </Button>
        </Stack>
      </Box>
    </Stack>
  );
}
